import { Button } from '~/components/ui/Button';
import { WrapperWidget, TrendBadge } from '@agentselly/ui';
import { useTranslate } from '@tolgee/react';
import { AppLink } from '~/components/AppLink';
import { Icon } from '~/components/Icon';

interface Props {
  readonly value?: number;
  readonly changeInLastWeek?: number;
  readonly title: string;
  readonly text: string;
  readonly detailLink: string;
  readonly marketplaceLink: string;
  readonly infoText?: string;
}

export function CockpitAdvertisementWidget(props: Props) {
  const { t } = useTranslate();
  return (
    <WrapperWidget title={t(props.title)}>
      <div className="h-full flex flex-col gap-y-6">
        <div className="my-auto">
          <div className="flex items-center gap-x-6">
            {props.value !== null && props.value !== undefined ? (
              <span className="text-3xl font-bold tabular-nums">
                {props.value}
              </span>
            ) : (
              <div className="flex items-center gap-2">
                <Icon
                  icon="pieLineGraphDesktop"
                  className="w-5 h-5 text-gray-400"
                />
                <span className="text-lg text-gray-500 dark:text-gray-400">
                  {t('cockpit_ad_views_no_data') || 'Keine Ansichten'}
                </span>
              </div>
            )}
            {props.changeInLastWeek !== null &&
            props.changeInLastWeek !== undefined &&
            props.changeInLastWeek !== 0 ? (
              <TrendBadge value={props.changeInLastWeek} />
            ) : null}
          </div>
        </div>

        <div className="self-start flex gap-x-4">
          {props.detailLink ? (
            <AppLink
              to={props.detailLink}
              data-track="immodossier cockpit advertisement details"
            >
              <Button
                primary
                showArrow
              >
                {t('cockpit_advertisement_widget_details_button_text')}
              </Button>
            </AppLink>
          ) : (
            <Button className="invisible">
              _
              {/* this button is only here to ensure alignment of elements within widget doesn't depend on presence of props.detailLink */}
            </Button>
          )}

          {props.marketplaceLink ? (
            <a
              href={props.marketplaceLink}
              target="_blank"
              rel="noreferrer"
              data-track="immodossier cockpit advertisement marketplace"
            >
              <Button showArrow>
                {t('cockpit_advertisement_widget_marketplace_button_text')}
              </Button>
            </a>
          ) : null}
        </div>
      </div>
    </WrapperWidget>
  );
}
